import { Dialog as MaterialDialog, type DialogProps as MuiDialogProps } from '@mui/material';
import React, { useCallback } from 'react';

import { CloseButton } from '../CloseButton/CloseButton';

interface DialogProps extends MuiDialogProps {
  onClose: {
    bivarianceHack(event, reason: 'backdropClick' | 'escapeKeyDown' | 'closeButtonClick'): void;
  }['bivarianceHack'];
}

export const Dialog: React.FC<DialogProps> = ({ children, ...props }) => {
  const onCloseButtonClock = useCallback(
    (event) => {
      if (props.onClose) {
        props.onClose(event, 'closeButtonClick');
      }
    },
    [props]
  );

  return (
    <MaterialDialog {...props}>
      <CloseButton onClick={onCloseButtonClock} />
      {children}
    </MaterialDialog>
  );
};
